import auth from "../middleware/auth";

export default [{
  path: "/ministry/dashboard/",
  component: () =>
    import ("./../views/ministry/Dashboard.vue"),
  meta: {
    middleware: [auth],
    breadcrumb: [{
      title: "Home",
      url: "/"
    }]
  },

  pageTitle: "dashboard",
  rule: "editor"
},
  {
    path: "/ministry/info_objects/:id",
    component: () =>
      import ("./../views/ministry/infoObjects.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Мониторинг объектов",
          i18n: "navmenu.analytics.object_monitoring",
          active: false,
          url: "/objects_list"
        },
        {
          i18n: "navmenu.analytics.info_object",
          title: "Информация об объекте",
          active: true
        }
      ]
    },

    pageTitle: "infoObjects",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco5",
    name: "map_eco5",
    component: () =>
      import ("./../views/ministry/MapEco5.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true
        },
        {
          title: "Карта концентрации",
          i18n: "navmenu.analytics.concentration_map",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco",
    name: "map_eco",
    component: () =>
      import ("./../views/ministry/MapEco.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true
        },
        {
          i18n: "navmenu.analytics.MIZ_subjects_map",
          title: "Карта субъектов МИЗ",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco_polutions/:id/",
    name: "map_eco_polutions_id",
    component: () =>
      import ("./../views/ministry/MapEcoPolutions.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Карта субъектов МИЗ источники",
          i18n: 'navmenu.analytics.MIZ_subjects_map_sources',
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco_polutions",
    name: "map_eco_polutions",
    component: () =>
      import ("./../views/ministry/MapEcoPolutions.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Карта субъектов МИЗ источники",
          i18n: 'navmenu.analytics.MIZ_subjects_map_sources',
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },

  {
    path: "/ministry/map_eco2",
    name: "map_eco2",
    component: () =>
      import ("./../views/ministry/MapEco2.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Карта МИЗ почвы",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco3",
    name: "map_eco3",
    component: () =>
      import ("./../views/ministry/MapEco3.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Карта Узбекистана",
          i18n: "navmenu.analytics.uzbekistan_map",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },

  {
    path: "/ministry/map_eco6",
    name: "map_eco6",
    component: () =>
      import ("./../views/ministry/MapEco6.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Карта растительного мира и заповедников",
          i18n: "navmenu.analytics.plant_and_nature_reserves_map",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco7",
    name: "map_eco7",
    component: () =>
      import ("./../views/ministry/MapEco7.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Карта животного мира и заповедников",
          i18n: "navmenu.analytics.map_of_the_animal_world_and_reserves",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco3_1",
    name: "map_eco3_1",
    component: () =>
      import ("./../views/ministry/MapEco3_1.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Карта состояния атмосферного воздуха",
          i18n: 'navmenu.analytics.atmospheric_air_condition_map',
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco_water",
    name: "map_eco_water",
    component: () =>
      import ("./../views/ministry/MapEcoWater.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Карта водных ресурсов",
          i18n: "navmenu.analytics.water_resources_map",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },
  {
    path: "/ministry/map_eco4",
    name: "map_eco4",
    component: () =>
      import ("./../views/ministry/MapEco4.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: true

        },
        {
          title: "Эко карта",
          i18n: "navmenu.analytics.eco_map",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },

  {
    path: "/ministry/map_eco_dynamic",
    name: "map_eco_dynamic",
    component: () =>
      import ("./../views/ministry/MapEcoDynamicReport.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          i18n: "navmenu.analytics.index",
          active: false
        },
        {
          title: "Динамика субъектов МИЗ",
          i18n: "navmenu.analytics.dynamics_subjects_of_MIZ",
          active: true
        }
      ]
    },

    pageTitle: "Map",
    rule: "editor"
  },

  {
    path: "/objects_list",
    name: "objects_list",
    component: () =>
      import ("./../views/ObjectsList.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
        title: "Home",
        url: "/"
      },
        {
          title: "Аналитика",
          active: false
        },
        {
          title: "Мониторинг объектов",
          i18n: "navmenu.analytics.object_monitoring",
          active: true
        }
      ]
    },
    pageTitle: "ObjectsList",
    rule: "editor"
  }
];
